var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasscodeTool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".passcode-tool-cls-1{fill:#4f4f52;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M95,68.5H89a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M92,71.5a.5.5,0,0,1-.5-.5V65a.5.5,0,0,1,1,0v6A.5.5,0,0,1,92,71.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M89.88,70.62a.5.5,0,0,1-.35-.85l4.24-4.24a.5.5,0,0,1,.71.71l-4.24,4.24A.5.5,0,0,1,89.88,70.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M94.12,70.62a.5.5,0,0,1-.35-.15l-4.24-4.24a.5.5,0,0,1,.71-.71l4.24,4.24a.5.5,0,0,1-.35.85Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M39,68.5H33a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M36,71.5a.5.5,0,0,1-.5-.5V65a.5.5,0,0,1,1,0v6A.5.5,0,0,1,36,71.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M33.88,70.62a.5.5,0,0,1-.35-.85l4.24-4.24a.5.5,0,0,1,.71.71l-4.24,4.24A.5.5,0,0,1,33.88,70.62Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M38.12,70.62a.5.5,0,0,1-.35-.15l-4.24-4.24a.5.5,0,0,1,.71-.71l4.24,4.24a.5.5,0,0,1-.35.85Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M67,68.5H61a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M64,71.5a.5.5,0,0,1-.5-.5V65a.5.5,0,0,1,1,0v6A.5.5,0,0,1,64,71.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M61.88,70.62a.5.5,0,0,1-.35-.85l4.24-4.24a.5.5,0,0,1,.71.71l-4.24,4.24A.5.5,0,0,1,61.88,70.62Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M66.12,70.62a.5.5,0,0,1-.35-.15l-4.24-4.24a.5.5,0,0,1,.71-.71l4.24,4.24a.5.5,0,0,1-.35.85Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M53,68.5H47a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M50,71.5a.5.5,0,0,1-.5-.5V65a.5.5,0,0,1,1,0v6A.5.5,0,0,1,50,71.5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M47.88,70.62a.5.5,0,0,1-.35-.85l4.24-4.24a.5.5,0,0,1,.71.71l-4.24,4.24A.5.5,0,0,1,47.88,70.62Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M52.12,70.62a.5.5,0,0,1-.35-.15l-4.24-4.24a.5.5,0,0,1,.71-.71l4.24,4.24a.5.5,0,0,1-.35.85Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M81,68.5H75a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M78,71.5a.5.5,0,0,1-.5-.5V65a.5.5,0,0,1,1,0v6A.5.5,0,0,1,78,71.5Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M75.88,70.62a.5.5,0,0,1-.35-.85l4.24-4.24a.5.5,0,0,1,.71.71l-4.24,4.24A.5.5,0,0,1,75.88,70.62Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M80.12,70.62a.5.5,0,0,1-.35-.15l-4.24-4.24a.5.5,0,0,1,.71-.71l4.24,4.24a.5.5,0,0,1-.35.85Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "passcode-tool-cls-1",
    d: "M102,60a2,2,0,0,1,2,2V74a2,2,0,0,1-2,2H26a2,2,0,0,1-2-2V62a2,2,0,0,1,2-2h76m0-2H26a4,4,0,0,0-4,4V74a4,4,0,0,0,4,4h76a4,4,0,0,0,4-4V62a4,4,0,0,0-4-4Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasscodeTool);
export default __webpack_public_path__ + "static/media/passcode_tool.413b71d2672941607613b3116c5d07d6.svg";
export { ForwardRef as ReactComponent };